import {useEffect} from 'react'
import {Link as RouterLink} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import Seo from '../components/seo/Seo'
import {softwareApplicationSchema} from '../components/seo/schema'
import {trackEvent} from '../../common/analytics/trackEvent'
import '../components/seo/SeoPage.css'

interface ToolCard {
  to: string
  cardKey: string
}

const TOOL_CARDS: ToolCard[] = [
  {to: '/icon-generator', cardKey: 'iconGenerator'},
  {to: '/qr-generator', cardKey: 'qrGenerator'},
  {to: '/image-converter', cardKey: 'imageConverter'},
  {to: '/video-to-gif', cardKey: 'videoToGif'},
  {to: '/app-store-creative-assets', cardKey: 'creativeAssets'},
]

// Content/listing hub for the free tools — unlike the individual tool pages
// (app-like utilities, deliberately excluded from prerender) this page is
// content-shaped like the guides/comparisons pages, so it IS prerendered.
const ToolsPage = () => {
  const {t} = useTranslation()

  useEffect(() => {
    trackEvent('tools_page_viewed')
  }, [])

  return (
    <div className="seo-root" data-prerender-ready>
      <Seo
        title="Free Tools — Icon Generator, QR Codes, Image Converter | Ecranify"
        description="Free browser-based tools for app developers: app icon ZIP generator, QR code generator, image format converter and video-to-GIF converter. No signup required."
        canonicalPath="/tools"
        jsonLd={[softwareApplicationSchema()]}
      />
      <div className="seo-grid" aria-hidden />

      <main className="seo-page">
        <header className="seo-hero">
          <span className="seo-eyebrow">
            <span className="seo-eyebrow-dot" />
            {t('tools.hero.eyebrow')}
          </span>
          <h1 className="seo-h1">
            {t('tools.hero.titlePrefix')} <em>{t('tools.hero.titleEm')}</em>
          </h1>
          <p className="seo-lede">{t('tools.hero.subtitle')}</p>
        </header>

        <section className="seo-section">
          <div className="seo-index-grid">
            {TOOL_CARDS.map((card) => (
              <RouterLink key={card.to} to={card.to} className="seo-index-card">
                <span className="seo-index-card-title">{t(`tools.cards.${card.cardKey}.title`)}</span>
                <span className="seo-index-card-summary">{t(`tools.cards.${card.cardKey}.desc`)}</span>
                <span className="seo-index-card-more">{t(`tools.cards.${card.cardKey}.cta`)} →</span>
              </RouterLink>
            ))}
          </div>
        </section>
      </main>
    </div>
  )
}

export default ToolsPage
